module.exports = __webpack_public_path__ + "img/number_0.46e90d49.png";